// Single audio entry point: every audible notification goes through playChime(), so the
// header mute toggle (useSoundPref) silences all of them. Web Audio, no asset needed.
let muted = false;

export function setChimeMuted(value) {
  muted = !!value;
}

export function playChime() {
  if (muted) return false;
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g);
    g.connect(ctx.destination);
    o.type = 'sine';
    o.frequency.setValueAtTime(880, ctx.currentTime);
    o.frequency.exponentialRampToValueAtTime(660, ctx.currentTime + 0.15);
    g.gain.setValueAtTime(0.18, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
    o.start(ctx.currentTime);
    o.stop(ctx.currentTime + 0.5);
    return true;
  } catch (_) {
    return false;
  }
}
